'use strict';

const { loadUserFactory } = require('../loadUser.js');

const userStates = ({ navigator: navigator_ }) => {
	const { loadUser } = loadUserFactory(navigator_);

	return [
		{
			name: 'site',
			url: '/:site',
			component: 'pmtSiteDir',
			resolve: {
				user: loadUser
			},
			redirectTo: 'site.DashboardV2'
		},
		{
			name: 'site.User',
			url: '/user',
			templateUrl: 'components/user/pmtUserMenu.html',
			redirectTo: 'site.User.Profile'
		},
		{
			name: 'site.User.EmailNotifications',
			url: '/email-notifications'
		},
		{
			name: 'site.User.Notifications',
			url: '/notifications'
		},
		{
			name: 'site.User.PostsNotifications',
			url: '/notifications-posts'
		},
		{
			name: 'site.User.PlacesAINotifications',
			url: '/notifications-places-ai'
		},
		{
			name: 'site.User.Legal',
			url: '/legal'
		},
		{
			name: 'site.User.ChangePassword',
			url: '/change-password'
		},
		{
			name: 'site.User.Profile',
			url: '/profile'
		},
		{
			name: 'site.User.Language',
			url: '/language'
		}
	];
};

module.exports = {
	userStates
};
